import script from "./StakingConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./StakingConfirm.vue?vue&type=style&index=0&id=2cbe0b9f&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbe0b9f"]])

export default __exports__